import { render } from "./Generator.vue?vue&type=template&id=500df50d&scoped=true"
import script from "./Generator.vue?vue&type=script&lang=js"
export * from "./Generator.vue?vue&type=script&lang=js"

import "./Generator.vue?vue&type=style&index=0&id=500df50d&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-500df50d"]])

export default __exports__